class FixedHeader extends HTMLElement {
	constructor() {
		super();
		
		this.$header = this;
		this.$wrap = this.querySelector('.fixed-header__wrap');
		this.$fixed = this.querySelector('.fixed-header__fixed');
		this.onScrollHandler = this.onScroll.bind(this);
		this.stickyClass = 'sticky';
		this.revealClass = 'reveal';
		this.animateClass = 'animate';

		// Height (in px) before stick nav will reveal after scrolling by header
		this.offset = 150;

	    window.addEventListener('scroll', this.onScrollHandler, false);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const headerHeight = this.$header.offsetHeight;

		if( scrollTop >= (headerHeight + this.offset) ){
			this.setSticky();
		}else if( scrollTop > headerHeight && scrollTop < (headerHeight + this.offset)){
			this.hide();
		}else{
			this.removeSticky();
		}
	}

	setSticky() {
		const headerHeight = this.$header.offsetHeight;

		this.style.height = `${headerHeight}px`;
		this.$wrap.top = `-${headerHeight}px`;
		this.classList.add(this.stickyClass);		
		this.reveal();	
	}

	removeSticky() {
		this.style.height = `auto`;
		this.$wrap.top = 0;
		this.classList.remove(this.stickyClass);
		this.hide();
	}

	reveal() {
		this.classList.add(this.revealClass);			
	}

	hide() {
		this.classList.remove(this.revealClass);			
	}
}

customElements.define('fixed-header', FixedHeader);